export const verificationCustomerStatus = {
  ACTIVE: "active",
  PENDING_DISCOUNT: "pendingDiscount",
  PENDING_VERIFICATION: "pendingVerification",
  EXPIRED: "expired",
  ERROR: "error",
};

export const verificationFormStatus = {
  SUCCESS: "success",
  PENDING: "pending",
  ERROR: "error",
};
